import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import * as JSONH from 'jsonh/js/jsonh';

import { SuccessResponse } from './../services/common-request.service';
import { AppSettings } from '../app.settings';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

	constructor(
		private toastr: ToastrService
	) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			// tap((event: HttpEvent<any>) => {
			// 	console.log(event);
			// 	// this.handleHttpRsp(event);
			// }, this.handleError),
			map((event) => {
				if (event instanceof HttpResponse) {
                    if (request.url.startsWith(AppSettings.serviceRootUrl)) {
                        return this.handleHttpRsp(event);
                    }
				}
				return event;
			}),
			catchError((err) => {
				return this.handleError(err);
			})
		);
	}
	handleHttpRsp(rsp) {
		const result: SuccessResponse<any> = {
			data: null,
			misc: {}
		};
		// Handle parseGeneral differently
		if (rsp.url.includes('parseGeneral')) {
			result.data = rsp.body.result;
			result.misc = rsp.body.misc;
			rsp.body.payload = result;
			return rsp;
		}

		const payload = rsp.body.payload;
		for (const prop in payload) {
			if (prop !== 'type' && prop !== 'content') {
				result[prop] = payload[prop];
			}
		}
		if (payload.type === 'jsonh') {
			result.data = JSONH.unpack(payload.content);
		} else if (payload.type === 'json') {
			result.data = payload.content;
		} else {
			result.data = payload;
		}
		rsp.body.payload = result;
		return rsp;
	}
	handleError(err: HttpErrorResponse) {
		console.log(err);
		if ((err.status + '')[0] === '4') { // If the status start with 4, like 400, 405, etc
			this.toastr.error(err.message);
		} else if (err.status === 500) {
			if (err.error.error.errorDetail === 'jwt expired') {
				//
			} else {
				if (err.error.error.errorDetail) {
					this.toastr.error(err.error.error.errorDetail);
				}
				if (err.error.error.errorMessage) {
					this.toastr.error(err.error.error.errorMessage);
				}
			}
			console.log(err.error.error.errorMessage);
			console.log(err.error.errorDetail);
		}
		return Observable.throw(err);
	}
}

